import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

/**
 * Boton de agregar al carrito reutilizable — DominandoTuNegocio.cl
 * Mismo flujo nativo de Horizon que product-form.js; abre el cart drawer.
 */
class DtnAddButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (this.button && this.button.dataset.dtnBound !== 'true') {
      this.button.dataset.dtnBound = 'true';
      this.button.addEventListener('click', this.onClick);
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  onClick = async (event) => {
    event.preventDefault();
    const variantId = this.dataset.variantId;
    if (!variantId || this.dataset.state === 'loading') return;

    this.dataset.state = 'loading';
    if (this.button) this.button.disabled = true;

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    if (sectionIds.length) formData.set('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    const cfg = fetchConfig('javascript', { body: formData });

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        ...cfg,
        headers: { ...cfg.headers, Accept: 'text/html' },
      }).then((r) => r.json());

      if (response.status) {
        this.dispatchEvent(
          new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID' })
        );
        const ajaxCart = await this.refreshCart();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: { didError: true, items: ajaxCart.items, source: 'dtn-add-button', itemCount: 1 },
        });
        this.reset();
        return;
      }

      this.dataset.state = 'added';

      const ajaxCart = await this.refreshCart();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'dtn-add-button',
          itemCount: 1,
          productId: this.dataset.productId,
          sections: response.sections,
          didError: false,
        },
      });

      this.openDrawer();
      setTimeout(() => this.reset(), 1800);
    } catch (error) {
      console.error('[dtn-add-button]', error);
      deferred.reject(error);
      this.reset();
    }
  };

  openDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    const dialog = drawer.querySelector('dialog');
    if (dialog && dialog.open) return;
    drawer.open();
  }

  reset() {
    this.dataset.state = 'idle';
    if (this.button) this.button.disabled = false;
  }

  async refreshCart() {
    const cartItems = document.querySelector('cart-items-component');
    if (cartItems) {
      await customElements.whenDefined('cart-items-component');
      return cartItems.fetchCartData();
    }
    const response = await fetch(`${Theme.routes.cart_url}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
    return response.json();
  }
}

if (!customElements.get('dtn-add-button')) {
  customElements.define('dtn-add-button', DtnAddButton);
}